import {MouseEvent, useState, useEffect} from "react";
import {selfcareLogout} from "../../util/request";
import {Link, useNavigate, useLocation} from "react-router-dom";
import {Customer} from "../../util/types";
import Icon from "./Icon";
import {useKeyPress} from "../../util/useKeyPress";
import {CURRENT_CUSTOMER_KEY} from "../../layouts/SelfcareLayout";
import Routing from "../../Routing.ts";
import IconOverview from "../icons/IconOverview.tsx";
import IconWifi from "../icons/IconWifi.tsx";
import IconCreditcard from "../icons/IconCreditcard.tsx";
import IconDocument from "../icons/IconDocument.tsx";
import IconMail from "../icons/IconMail.tsx";
import IconUser from "../icons/IconUser.tsx";
import IconLogout from "../icons/IconLogout.tsx";
import IconCross from "../icons/IconCross.tsx";
import IconUserMenu from "../icons/IconUserMenu.tsx";

export default function Menu(props: {customer: Customer}) {
    const navigate = useNavigate()
    const location = useLocation()
    const [showMenu, setShowMenu] = useState<boolean>(false)

    const menuClass: string = showMenu ? "menu-open" : "";

    const escPress = useKeyPress("Escape");

    useEffect(() => {
        escPress && setShowMenu(false)
    }, [escPress]);

    const activeMenuItem = (pathname: string): string => {
        if (pathname === location.pathname) {
            return "active"
        }
        return '';
    }

    const logout = (event: MouseEvent): void => {
        event.preventDefault();
        localStorage.removeItem(CURRENT_CUSTOMER_KEY)
        selfcareLogout().then(r => {
            if (r.code !== 200) {
                console.error(r)
                return
            }
            navigate(Routing.Selfcare.Login)
        })
    }

    const onMenuLinkClick = (): void => {
        setShowMenu(false);
        window.scrollTo({ top: 0});
    }

    return <>
        <button className="selfcare-menu-button open" onClick={() => setShowMenu(true)}>
            <Icon component={IconUserMenu} />
        </button>
        <nav className={`selfcare-menu ${menuClass}`}>
            <div className="selfcare-menu-button-container">
                <button className="selfcare-menu-button close" onClick={() => setShowMenu(false)}>
                    <Icon component={IconCross} />
                </button>
            </div>
            <ul className="selfcare-menu-items">
                {props.customer.customer_context.can_request_sbbu &&
                    <li onClick={onMenuLinkClick} className="selfcare-menu-sbbu">
                        <Link to={Routing.Selfcare.TerminateExisting}>
                            Opsig hos min nuværende udbyder
                        </Link>
                    </li>
                }

                <li onClick={onMenuLinkClick}>
                    <Link to={Routing.Selfcare.Index} className={"choose " + activeMenuItem(Routing.Selfcare.Index)}>
                        <Icon component={IconOverview} />
                        <span className="text">Overblik</span>
                    </Link>
                </li>

                <li onClick={onMenuLinkClick}>
                    <Link to={Routing.Selfcare.Internet} className={"choose " + activeMenuItem(Routing.Selfcare.Internet)}>
                        <Icon component={IconWifi} />
                        <span className="text">Internet</span>
                    </Link>
                </li>

                <li onClick={onMenuLinkClick}>
                    <Link to={Routing.Selfcare.Card} className={"choose " + activeMenuItem(Routing.Selfcare.Card)}>
                        <Icon component={IconCreditcard} />
                        <span className="text">Betaling</span>
                    </Link>
                </li>

                <li onClick={onMenuLinkClick}>
                    <Link to={Routing.Selfcare.Bills} className={"choose " + activeMenuItem(Routing.Selfcare.Bills)}>
                        <Icon component={IconDocument} />
                        <span className="text">Regninger</span>
                    </Link>
                </li>

                <li onClick={onMenuLinkClick}>
                    <Link to={Routing.Selfcare.Letters} className={"choose " + activeMenuItem(Routing.Selfcare.Letters)}>
                        <Icon component={IconMail} />
                        <span className="text">Breve</span>
                    </Link>
                </li>

                <li onClick={onMenuLinkClick}>
                    <Link to={Routing.Selfcare.Account} className={"choose " + activeMenuItem(Routing.Selfcare.Account)}>
                        <Icon component={IconUser} />
                        <span className="text">Profil</span>
                    </Link>
                </li>

                <li>
                    <a onClick={logout} href={'/#'} className="choose" id="selfcare-logout-link" rel="nofollow">
                        <Icon component={IconLogout} />
                        <span className="text">Log&nbsp;ud</span>
                    </a>
                </li>
            </ul>
        </nav>
    </>
}
